import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import dayjs from 'dayjs';

export default function PresenceByQuartierCurve({ sundays, selectedSunday }) {
  const [sunday, setSunday] = useState(null);
  const [chartData, setChartData] = useState({ series: [], options: {} });

  useEffect(() => {
    if (!sundays || sundays.length === 0) return;

    const sundayFound = selectedSunday ?
      sundays.find(
        (d) => new Date(d.date).getTime() === new Date(selectedSunday).getTime()
      ) :
      sundays[sundays.length - 1];

    setSunday(sundayFound);
  }, [sundays, selectedSunday]);

  useEffect(() => {
    if (!sunday) return;

    const quartiers = sunday.quartiers.map((q) => q.quartier);
    const counts = sunday.quartiers.map((q) => q.count);

    const endIndex = quartiers.length - 1;

    const filteredQuartiers = quartiers.slice(0, endIndex + 1);
    const filteredCounts = counts.slice(0, endIndex + 1);

    setChartData({
      series: [{ name: 'Présences', data: filteredCounts }],
      options: {
        chart: {
          id: 'quartier-area', type: 'area', height: 350
        },
        dataLabels: { enabled: false },
        stroke: { curve: 'smooth' },
        xaxis: { categories: filteredQuartiers, title: { text: 'Quartiers' } },
        yaxis: { title: { text: 'Présences uniques' } },
        tooltip: { shared: true, intersect: false },
        title: {
          text: `${dayjs(sunday.date).format('DD MMMM YYYY').toUpperCase()}`,
          align: 'center',
          style: { fontSize: '14px' }
        }
      }
    });
  }, [sunday]);

  return (
    <ReactApexChart
      series={chartData.series}
      options={chartData.options}
      type='area'
      height={350}
      width='100%'
    />
  );
}
